/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./operateButton.vue?vue&type=template&id=19632a53&scoped=true&"
import script from "./operateButton.vue?vue&type=script&lang=js&"
export * from "./operateButton.vue?vue&type=script&lang=js&"
import style0 from "./operateButton.vue?vue&type=style&index=0&id=19632a53&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19632a53",
  null
  
)

export default component.exports